import { getLocalStorage, getUrlParam, setLocalStorage } from '../../../utils';
import { normalizeUserData } from '../../../utils/normalizer';
import { usersTypes, actionStatuses } from '../../types';

const defaultState = {
  isFetchUser: false,
  signInErrorMessage: '',
  isSigningOut: false,
  user: {
    company: {},
    email: getLocalStorage('email'),
    userId: getLocalStorage('userId'),
    cwConfiguration: getLocalStorage('cwConfiguration'),
    chatConfiguration: getLocalStorage('chatConfiguration'),
    botInstalled: getLocalStorage('botInstalled'),
    flowItemsReady: getLocalStorage('flowItemsReady'),
    msTeamsHasNewConfiguration: getLocalStorage('msTeamsHasNewConfiguration'),
    slackHasNewConfiguration: getLocalStorage('slackHasNewConfiguration'),
    actionPlatform: getLocalStorage('actionPlatform'),
    appId: getUrlParam('app_id') || getLocalStorage('appId')
  }
};

const map = {
  [`${usersTypes.SAVE_TOKEN}`]: (state, action) => ({
    ...state,
    user: { ...state.user, token: action.payload.token }
  }),
  [`${usersTypes.SAVE_APP_ID}`]: (state, action) => {
    const { appId } = action.payload;
    setLocalStorage({ appId });

    return {
      ...state,
      user: { ...state.user, appId }
    };
  },
  [`${usersTypes.SWITCH_WORKSPACE}`]: state => ({
    ...defaultState,
    user: { ...defaultState.user, token: state.user.token, appId: '' }
  }),

  [`${usersTypes.SET_IS_SIGNING_OUT}`]: (state, action) => ({
    ...state,
    isSigningOut: action.payload
  }),

  // SIGN_IN
  [`${usersTypes.SIGN_IN}${actionStatuses.FULFILLED}`]: (state, action) => ({
    ...state,
    user: {
      ...state.user,
      ...normalizeUserData(action.payload.data)
    },
    isFetchUser: false,
    signInErrorMessage: ''
  }),
  [`${usersTypes.SIGN_IN}${actionStatuses.PENDING}`]: state => ({
    ...state,
    isFetchUser: true,
    signInErrorMessage: ''
  }),
  [`${usersTypes.SIGN_IN}${actionStatuses.REJECTED}`]: (state, action) => ({
    ...state,
    isFetchUser: false,
    signInErrorMessage:
      action.payload?.response?.data?.message ||
      'Failed to sign in, please refresh the page. If it persists please contact help@getthread.com'
  })
};

export default function users(state = defaultState, action) {
  return (map[action.type] && map[action.type](state, action)) || state;
}
